import { Box, Text } from '@factorialco/deprecated-design-system'
import { BankingBankAccountFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'

export interface SidepanelAccountingInfoProps {
  legalEntityId: string
  disabled: boolean
  bankAccount: BankingBankAccountFragment
  selectedLedgerAccountId?: string
  onAccountingInfoChange: (newId: string) => void
}

export function SidepanelAccountingInfo({
  legalEntityId,
  disabled,
  bankAccount,
  onAccountingInfoChange,
  selectedLedgerAccountId,
}: SidepanelAccountingInfoProps) {
  const currentAccountResourceId = selectedLedgerAccountId ?? bankAccount.accountResource?.id

  return (
    <Box gap={'s4'}>
      <Text.Normal color="grey1000" weight="medium">
        {i18n.t('banking.accounts.accounting.ledger_account')}
      </Text.Normal>
      <Text color="grey800" weight="normal" size="200">
        {i18n.t('banking.accounts.accounting.accounting_account_label')}
      </Text>
      <>
        <LedgerAccountSelector
          legalEntityId={legalEntityId}
          currentLedgerAccountName={formatAccountName(bankAccount.accountResource?.account)}
          types={['bank']}
          disabled={disabled}
          onSelect={onAccountingInfoChange}
          selectedLedgerAccountIdProp={currentAccountResourceId}
        />
      </>
    </Box>
  )
}
